// #/services/workflows/createNode.ts

import { Node } from 'reactflow';
import { v4 as uuidv4 } from 'uuid';

import { ActionNodeData, NodeType, Prerequisite } from '#/types/workspace';

export async function createActionNode(args: {
  id: string;
  position: { x: number; y: number };
  type?: NodeType;
  data: {
    uuid?: string;
    isLateral?: boolean;
    logoUrl?: string;
    serviceKey?: string;
    actionKey?: string;
    actionVerb?: string;
    actionEndpoint?: string;
    context?: Record<string, any>;
    prerequisites?: Prerequisite[];
    inputSchema?: Record<string, any>;
    inputValues?: any;
    outputSchema?: Record<string, any>;
  };
}): Promise<Node<ActionNodeData>> {
  const {
    id,
    position,
    type: nodeType = 'turbo',
    data: {
      uuid = uuidv4(),
      isLateral = false,
      logoUrl,
      serviceKey,
      actionKey,
      // actionVerb,
      // actionEndpoint,
      context = {},
      prerequisites = [],
      inputSchema,
      inputValues,
      outputSchema,
      // ...restData
    },
    // ...rest
  } = args;

  let actionDetails;
  if (serviceKey != null && actionKey != null) {
    try {
      const response = await fetch(
        `/api/registry/getActionDetails?${new URLSearchParams({
          serviceKey,
          actionKey,
        })}`,
      );
      actionDetails = await response.json();
    } catch (error: any) {
      console.error(error);
    }
    console.debug('actionDetails:', actionDetails);
  }

  const {
    // serviceKey,
    // serviceUrlRoot,
    serviceLogoUrl,
    // actionKey,
    actionVerb,
    // actionPath,
    actionEndpoint,
    defaultContext,
    defaultPrerequisites,
    inputSchema: _inputSchema,
    defaultInputValues,
    outputSchema: _outputSchema,
  } = actionDetails ?? {};

  return {
    // ...rest,
    id,
    position,
    type: nodeType,
    data: {
      // ...restData,
      uuid,
      type: 'action',
      title: serviceKey,
      subline: actionKey,
      icons: ['FunctionIcon'],
      isLateral,
      logoUrl: logoUrl ?? serviceLogoUrl,
      serviceKey,
      actionKey,
      actionVerb: actionKey == null ? null : actionVerb,
      actionEndpoint: actionKey == null ? null : actionEndpoint,
      context: context ?? defaultContext ?? {},
      prerequisites: prerequisites ?? defaultPrerequisites ?? [],
      inputSchema:
        actionKey == null ? null : inputSchema ?? _inputSchema ?? null,
      inputValues:
        actionKey == null
          ? null
          : { ...(defaultInputValues ?? {}), ...(inputValues ?? {}) },
      outputSchema:
        actionKey == null ? null : outputSchema ?? _outputSchema ?? null,
    },
  };
}

export default createActionNode;
